import React, { useState, useEffect } from "react";

const TableGrid = ({ tables, selectedTable, setSelectedTable, pendingOrdersByTable ,KOTByTable}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {screenWidth > 1025 ? (
        <div className="p-4 bg-white border-b overflow-auto max-h-48">
          <div className="grid grid-cols-5 gap-3">
            {tables.map((table) => {
              const pendingOrders = pendingOrdersByTable[table.id] || [];
              const pendingCount = pendingOrders.length;
              const kotItemsForTable = KOTByTable && KOTByTable[table.id] || [];
        
              // Calculate unprintedCount for THIS specific table
              const unprintedKOTItems = kotItemsForTable.items 
                ? kotItemsForTable.items.filter(item => item && !item.isPrinted)
                : [];
              const unprintedCount = unprintedKOTItems.length || 0;
              return (
                <button
                key={table.id}
                onClick={() => setSelectedTable(table)}
                className={`p-2 rounded-lg border transition-all relative h-20 ${
                  pendingCount > 0
                    ? "bg-yellow-600 text-white border-yellow-700"
                    : selectedTable?.id === table.id
                    ? "bg-blue-600 text-white border-blue-700"
                    : table.orders.length > 0
                    ? "bg-green-600 text-white border-green-700"
                    : "bg-gray-100 text-gray-800 border-gray-200"
                }`}
              >
              
                  <h3 className="font-bold">
                    {String(table.id).startsWith("takeaway") ? table.name : `Table ${table.id}`}
                  </h3>
                  {Number(table.currentBill) > 0 && (
                    <div className="text-xs mt-1">
                      <p className="opacity-90">Items: {table.orders.length}</p>
                      <p className="font-bold">₹{table.currentBill.toFixed(2)}</p>
                    </div>
                  )}
                    {unprintedCount > 0 && pendingCount <= 0 && Number(table.currentBill) <= 0 && (
                <div className="mt-1 text-center">
                  <p className="text-[8px] sm:text-[10px] opacity-90">
                   Selected Items: {unprintedCount}
                  </p>
                 
                </div>
              )}
                  {pendingCount > 0 && (
                    <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white text-xs flex items-center justify-center">
                      {pendingCount}
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="p-4 bg-white border-b max-h-[230px] overflow-y-auto">
          <div className="grid grid-cols-4 lg:grid-cols-6 gap-4 max406:grid-cols-2">
            {tables.map((table) => {
              const pendingOrders = pendingOrdersByTable[table.id] || [];
              const pendingCount = pendingOrders.length;
              const kotItemsForTable = KOTByTable && KOTByTable[table.id] || [];
        
              // Calculate unprintedCount for THIS specific table
              const unprintedKOTItems = kotItemsForTable.items 
                ? kotItemsForTable.items.filter(item => item && !item.isPrinted)
                : [];
              const unprintedCount = unprintedKOTItems.length || 0;
              return (
                <button
                  key={table.id}
                  onClick={() => setSelectedTable(table)}
                  className={`p-4 rounded-lg border transition-all flex flex-col justify-between relative ${
                    pendingCount > 0
                    ? "bg-yellow-600 text-white border-yellow-700"
                    : selectedTable?.id === table.id
                    ? "bg-blue-600 text-white border-blue-700"
                    : table.orders.length > 0
                    ? "bg-green-600 text-white border-green-700"
                    : "bg-gray-100 text-gray-800 border-gray-200"
                } min-h-[80px] min-w-[80px] max-h-[100px] max-w-[100px]`}
                >
                  <h3 className="font-bold text-xs max1008:text-sm">
                    {String(table.id).startsWith("takeaway") ? table.name : `Table ${table.id}`}
                  </h3>
                  {table.currentBill > 0 && (
                    <div className="mt-1 text-center">
                      <p className="text-[10px] max1008:text-xs opacity-90">
                        Items: {table.orders.length}
                      </p>
                      <p className="font-bold text-xs">₹{table.currentBill.toFixed(2)}</p>
                    </div>
                  )}
                  {unprintedCount > 0 && pendingCount <= 0 && Number(table.currentBill) <= 0 && (
                <div className="mt-1 text-center">
                  <p className="text-[8px] sm:text-[10px] opacity-90">
                   Selected Items: {unprintedCount}
                  </p>
                 
                </div>
              )}
                  {pendingCount > 0 && (
                    <div className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center">
                      {pendingCount}
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default TableGrid;